import { useQuery } from '@tanstack/react-query'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'
import { constructUrlWithParams } from '../helpers'

export interface GetDocumentRes {
  signedUrl: string
  _id: string
  hash: string
  type: string
  name: string
  pool: string
  subtype: string
  title: string
  category: string
  uploadedDate: Date
  userBookmark?: boolean
  vesselName?: string
}

export function useGetDocument({
  documentId,
  attachment,
  disabled,
}: {
  documentId?: string
  attachment?: boolean
  disabled?: boolean
}) {
  const fetchRequest = useFetch<GetDocumentRes>()

  const url = constructUrlWithParams(`/files/${documentId}`, {
    attachment,
  })

  return useQuery({
    queryKey: ['/files', documentId, attachment],
    queryFn: async () => await fetchRequest(`${apiBase()}${url}`),
    enabled: !disabled && !!documentId,
  })
}
